import { render } from "./CompanyFeedbackCell.vue?vue&type=template&id=73503e89"
import script from "./CompanyFeedbackCell.vue?vue&type=script&lang=js"
export * from "./CompanyFeedbackCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__